<template>
    <div class="alert" v-prevent-overscroll>
        <div class="alert-area">
            <div class="exchange-wrapper" :style="wrapperStyle">
                <div class="card-count" :style="countStyle">{{deductionCurrent}}/{{deductionCount}}</div>
                <div class="card-item" v-for="(item, index) in exchangeCardList" :key="index" :style="item.style" @click.stop="selectCard(item, index)">
                    <div class="card-item-border" :style="{borderColor: item.borderColor}"></div>
                    <img class="card-item-img" :src="item.holdCount ? item.cardHeadBrightImage : item.cardHeadImage" />
                    <div class="card-name" :style="item.nameStyle">{{item.prizeName || item.cardName}}</div>
                </div>
                <div class="submit-btn" :style="submitStyle" v-debounce:submitExchangePrize.prevent></div>
            </div>
            <div class="close-area">
                <div class="close-border"></div>
                <img class="close-icon" :src="closeIconUrl" @click.stop="closeExchangePrize" />
            </div>
        </div>
    </div>
</template>

<script>

let closeIcon = require('@/assets/imgs/close.png')

export default {

    name: 'exchangePrize',

    props: {
        
        info: {
			type: Object,
		},

    },

    inject: ['$$cardList'],

    computed: {

        $cardList() {
            return this.$$cardList()
        },

    },

    data() {

        return {   

            closeIconUrl: closeIcon,

            exchangeCardList: [], // 分享卡片列表

            wrapperStyle: {}, // 包裹框样式

            countStyle: {}, // 数量样式

            submitStyle: {}, // 提交样式

            deductionCurrent: 0, // 当前选择的卡片数量

            deductionCount: 0, // 抵扣需要的卡片数量

            submitInfo: { // 提交信息
                cardIdList: [], // 选中的卡片id列表
                exchangePrizeId: '', // 兑换奖品id
                column: '', // 栏位号
            }, 

        }

    },

    watch: {
        deductionCurrent: {
            handler(val) {
                let status = (val == this.deductionCount)
                this.toggleSubmitBtnStyle(status)
            },
            deep: true
        }

    },

    mounted() {

        this.init()

    },

    methods: {

        init() {

            let { $$opts } = this.info

            this.initDeductionConfig($$opts)

            this.initStyle(this.info)

            this.initCardList(this.info)

        },

        initDeductionConfig(config) { // 初始化兑换配置

            this.deductionCurrent = 0
            
            this.deductionCount = config.deductionCount || 0

            this.$set(this.submitInfo, 'exchangePrizeId', config.prizeId || '')
            this.$set(this.submitInfo, 'column', config.column || 1) // 之类

        },

        initStyle(val) { // 初始化页面元素样式

            let config = val && val.prizeExchange && val.prizeExchange

            let { baseConfig, cardCount, submitBtn } = config
           
            let transform = (config, imgKey, type) => {

                let options = {}

                if (config.position1 && config.position1.type) {
                    options[`${config.position1.type}`] =  `${config.position1.value || 0}px`
                }

                if (config.position2 &&  config.position2.type) {
                    options[`${config.position2.type}`] =  `${config.position2.value || 0}px`
                }
                
                if (config.width) {
                    options.width = `${config.width}px`
                }

                if (config.height) {
                    options.height = `${config.height}px`
                }

                options.color      = config.color
                options.fontSize   = `${config.fontSize}px`
                options.textStroke = config.stroke ? `1px ${config.stroke}` : ''
                options.fontWeight = config.fontStyle && config.fontStyle.indexOf('bold') !== -1 ? 'bold' : ''
			    options.fontStyle  = config.fontStyle && config.fontStyle.indexOf('italic') !== -1 ? 'italic' : ''

                if (imgKey) {
                    if (config[imgKey].url) {
                        let background = {
                            backgroundImage: `url(${config[imgKey].url})`,
                            backgroundSize: `100% 100%`,
                            backgroundPosition: '0px 0px',
                        }
                        options= Object.assign(options, background)
                    }
                }
            
                if (type === 'submitBtn') {
                    let background = {
                        active: {
                            backgroundImage: `url(${config['activeBtn'].url})`,
                            backgroundSize: `100% 100%`,
                            backgroundPosition: '0px 0px',
                        },
                        inactive: {
                            backgroundImage: `url(${config['inactiveBtn'].url})`,
                            backgroundSize: `100% 100%`,
                            backgroundPosition: '0px 0px',
                        }
                    }
                    options= Object.assign(options, background)
                }

                return options
            }

            this.wrapperStyle = baseConfig && transform(baseConfig, 'img') || {}
 
            this.countStyle   = cardCount && transform(cardCount) || {}

            let originalSubmitBtnStyle = submitBtn && transform(submitBtn, '', 'submitBtn') || {}

            originalSubmitBtnStyle =  Object.assign(originalSubmitBtnStyle, originalSubmitBtnStyle.inactive)

            this.submitStyle = originalSubmitBtnStyle

        },

        initCardList(val) { // 初始化卡片列表

            let list = []
            if (val.$$opts && val.$$opts.beSpecialCardDeduction) {
                list = JSON.parse(JSON.stringify(val.$$opts && val.$$opts.deductionCards)) || []
            } else {
                list = JSON.parse(JSON.stringify(this.$cardList))
            }

            let configList = val.prizeExchange && val.prizeExchange.cardSelect && val.prizeExchange.cardSelect.configList

            let nameConfig = val.prizeExchange && val.prizeExchange.cardText

            let initItemStyle = (item) => {
                let options = {}
                if (item.position1.type) {
                    options[`${item.position1.type}`] =  `${item.position1.value || 0}px`
                }

                if (item.position2.type) {
                    options[`${item.position2.type}`] =  `${item.position2.value || 0}px`
                }
                
                if (item.width) {
                    options.width = `${item.width}px`
                }

                if (item.height) {
                    options.height = `${item.height}px`
                }

                return options
            }

            let initNameStyle = (config) => {
                let options = {}

                if (config.position1 && config.position1.type) {
                    options[`${config.position1.type}`] =  `${config.position1.value || 0}px`
                }

                if (config.position2 && config.position2.type) {
                    options[`${config.position2.type}`] =  `${config.position2.value || 0}px`
                }

                options.color      = config.color
                options.fontSize   = `${config.fontSize}px`
                options.textStroke = config.stroke ? `1px ${config.stroke}` : ''
                options.fontWeight = config.fontStyle.indexOf('bold') !== -1 ? 'bold' : ''
			    options.fontStyle  = config.fontStyle.indexOf('italic') !== -1 ? 'italic' : ''

                return options
            }
            
            list.forEach(item => {
                configList.forEach($item => {
                    if (item.cardId === $item.cardId) {
                        item = Object.assign(item, { $borderColor: $item.borderColor, borderColor: 'transparent', $selected: false }, {style: $item && initItemStyle($item) || {}, nameStyle: nameConfig && initNameStyle(nameConfig) || {}})
                    }
                })
            })
            
            this.exchangeCardList = list

        },

        selectCard(e, i) { // 选择卡片
            if (!e.holdCount) {
                let txt = '还未点亮，暂不能选~'
                this.toast(txt)
            } else {
                let list = this.exchangeCardList
                let item = list[i]
                let cacheCurrent = this.deductionCurrent
                if (this.deductionCurrent < this.deductionCount) { // 当前选中的数量小于 需要的数量
                    if (item.$selected) {
                        this.$set(this.exchangeCardList[i], 'borderColor', 'transparent')
                        this.$set(this.exchangeCardList[i], '$selected',   false)
                        cacheCurrent -= 1
                    } else {
                        this.$set(this.exchangeCardList[i], 'borderColor', item.$borderColor)
                        this.$set(this.exchangeCardList[i], '$selected',   true)
                        cacheCurrent += 1
                    }
                    this.deductionCurrent = cacheCurrent
                } else {
                    if (item.$selected) {
                        this.$set(this.exchangeCardList[i], 'borderColor', 'transparent')
                        this.$set(this.exchangeCardList[i], '$selected',   false)
                        cacheCurrent -= 1
                    }
                    this.deductionCurrent = cacheCurrent
                }
            }
        },

        toggleSubmitBtnStyle(status) { // 切换提交按钮的状态
            let style = this.submitStyle
            if (status) {
                style = Object.assign(style, style.active)
            } else {
                style = Object.assign(style, style.inactive)
            }
            this.submitStyle = style
        },

        submitExchangePrize() { // 提交兑换奖品
            if (this.deductionCurrent < this.deductionCount) {
                return
            } else {
                let list = this.exchangeCardList
                let selectedCardList = []
                list.forEach(item => {
                    if (item && item.$selected) {
                        selectedCardList.push(item.cardId)
                    }
                })

                this.$set(this.submitInfo, 'cardIdList', selectedCardList)
                
                this.$emit('emitEvent', {
                    type: 'submitExchangePrize',
                    data: this.submitInfo,
                    options: null
                })
                
                this.$emit('emitEvent', {
                    type: 'closeExchangePrize',
                    data: null,
                    options: null
                })
            }
        },

        closeExchangePrize() {
            this.$emit('emitEvent', {
				type: 'closeExchangePrize',
				data: null,
				options: null
			})
        },

        toast(txt, duration) { // 封装统一的信息处理函数
            this.$toast({
                styles: {
                    maskColor: "rgba(0,0,0,0)",
                    background: "rgba(0,0,0,0.4)",
                    messageColor: "#fff"
                },
                content: txt,
                duration: duration || 2000
            })
        },


    },

}
</script>

<style lang="scss" scoped>

.alert {
  position: fixed;
  width: 100%;
  height: 100vh;
  top: 0;
  left: 0;
  z-index: 100;
  background: rgba(0, 0, 0, 0.8);
}

.alert .alert-area {
  height: 100%;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.exchange-wrapper {
    position: relative;
}
.card-count,
.card-item,
.submit-btn {
    position: absolute;
}

.card-item-border {
    position: absolute;
    top: 0;
    left: 0;
    border-radius: 100%;
    width: 100%;
    height: 100%;
    border: 3px solid transparent;
}

.card-item-img {
    width: 100%;
    height: 100%;
}

.card-name {
    position: absolute;
    width: 100%;
    text-align: center;
    font-size: 8px;
}

.close-area {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.close-border {
    border-left: 4px dashed #fff;
    height: 100px;
}

.close-icon {
    width: 68px;
    height: 68px;
}
</style>